import type { PatientStrings } from '../index';

export const or: PatientStrings = {
  titleOne: 'ଆପଣଙ୍କ ନୂଆ କ୍ରାଉନ୍',
  titleMany: 'ଆପଣଙ୍କ ନୂଆ କ୍ରାଉନ୍‌ଗୁଡ଼ିକ',
  tooth: 'ଦାନ୍ତ',
  teeth: 'ଦାନ୍ତ',
  both: 'ଦୁଇଟି',
  overview: 'ସମ୍ପୂର୍ଣ୍ଣ ଦୃଶ୍ୟ',
  front: 'ସାମ୍ନାରୁ',
  leftSide: 'ବାମ ପଟ',
  rightSide: 'ଡାହାଣ ପଟ',
  bitingSurface: 'ଚୋବାଇବା ପୃଷ୍ଠ',
  show: 'ଦେଖାନ୍ତୁ',
  newCrown: 'ନୂଆ କ୍ରାଉନ୍',
  newCrowns: 'ନୂଆ କ୍ରାଉନ୍‌ଗୁଡ଼ିକ',
  yourTeeth: 'ଆପଣଙ୍କ ଦାନ୍ତ ଓ ମାଢ଼ି',
  upperTeeth: 'ଉପର ଦାନ୍ତ',
  lowerTeeth: 'ତଳ ଦାନ୍ତ',
  hint: 'ଘୁରାଇବାକୁ ଟାଣନ୍ତୁ · ଜୁମ୍ ପାଇଁ ପିଞ୍ଚ କିମ୍ବା ସ୍କ୍ରୋଲ୍ କରନ୍ତୁ',
  zoomIn: 'ପାଖକୁ',
  zoomOut: 'ଦୂରକୁ',
  turnSlowly: 'ଧୀରେ ଘୁରାନ୍ତୁ',
  stopTurning: 'ଘୁରାଇବା ବନ୍ଦ କରନ୍ତୁ',
  backToStart: 'ଆରମ୍ଭକୁ ଫେରନ୍ତୁ',
  fullScreen: 'ପୂର୍ଣ୍ଣ ସ୍କ୍ରିନ୍',
  exitFullScreen: 'ପୂର୍ଣ୍ଣ ସ୍କ୍ରିନ୍‌ରୁ ବାହାରନ୍ତୁ',
  fromDentist: 'ଆପଣଙ୍କ ଦନ୍ତ ଡାକ୍ତରଙ୍କ ଠାରୁ',
  shadeNote: (shade) =>
    `ରଙ୍ଗ ପ୍ରାୟ ଶେଡ୍ ${shade} ଭଳି ଦେଖାଯାଇଛି। ପ୍ରକୃତ କ୍ରାଉନ୍‌ର ରଙ୍ଗ ଲ୍ୟାବ୍‌ରେ ମେଳ କରାଯାଏ।`,
  before: 'ପୂର୍ବରୁ',
  after: 'ପରେ',
  seeInRoom: 'ଆପଣଙ୍କ ଘରେ ଦେଖନ୍ତୁ',
  arNotSupported: 'କ୍ରାଉନ୍‌କୁ ଆପଣଙ୍କ ଘରେ ଦେଖିବା ପାଇଁ ଏହି ପୃଷ୍ଠାକୁ ଫୋନ୍‌ରେ ଖୋଲନ୍ତୁ।',
  appointmentTitle: 'କ୍ରାଉନ୍ ଲଗାଇବାର ଆପଣଙ୍କ ଆପଏଣ୍ଟମେଣ୍ଟ',
  confirm: 'ନିଶ୍ଚିତ କରନ୍ତୁ',
  confirmed: 'ନିଶ୍ଚିତ ହେଲା — ସେତେବେଳେ ଦେଖା ହେବ',
  anotherTime: 'ଅନ୍ୟ ସମୟ ମାଗନ୍ତୁ',
  anotherTimeSent: 'ଆପଣଙ୍କୁ ଅନ୍ୟ ସମୟ ଦରକାର ବୋଲି ଆମେ ଦନ୍ତ ଡାକ୍ତରଙ୍କୁ ଜଣାଇଛୁ।',
  language: 'ଭାଷା',
  largerText: 'ବଡ଼ ଅକ୍ଷର',
};
